import { useEffect, type CSSProperties } from "react";

import developingIdeasIcon from "./developing_ideas_icon_150101_transparent.png";

const pageStyles: CSSProperties = {
  alignItems: "center",
  background: "#ffffff",
  color: "#666666",
  display: "flex",
  height: "100dvh",
  justifyContent: "center",
  margin: 0,
  overflow: "hidden",
  width: "100%",
};

const watermarkStyles: CSSProperties = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "1.35rem",
  justifyContent: "center",
  opacity: 0.72,
  pointerEvents: "none",
  textAlign: "center",
  transform: "translateY(-0.45rem)",
};

const titleStyles: CSSProperties = {
  color: "rgba(102, 102, 102, 0.95)",
  fontFamily: '"OnePaper", "Xiaolai", cursive',
  fontSize: "clamp(2.3rem, 4.25vw, 4rem)",
  fontWeight: 400,
  lineHeight: 1,
};

const LibrariesOnePaper = () => {
  useEffect(() => {
    document.title = "libraries.onepaper";
  }, []);

  return (
    <main
      aria-label="libraries.onepaper"
      data-testid="biblioteca-libraries-onepaper"
      style={pageStyles}
    >
      <div style={watermarkStyles}>
        <img
          alt=""
          aria-hidden="true"
          src={developingIdeasIcon}
          style={{
            display: "block",
            filter: "grayscale(1) brightness(0.7)",
            height: "5.35rem",
            objectFit: "contain",
            width: "5.35rem",
          }}
        />
        <div style={titleStyles}>Em Desenvolvimento</div>
      </div>
    </main>
  );
};

export default LibrariesOnePaper;
